module.exports = __webpack_public_path__ + "static/img/gj_t.35ccaad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gj_t.png
// module id = lC2m
// module chunks = 1